import { DataSourceType } from './data-source-type'
import { ReportPresetType } from './report-preset-type'

//IMPORTANT: this file is auto-generated, any changes included will not be persisted, if extension is required please inherit from this class in separate file and inlcude your changes there

export interface IValuationModel {
  reportPresetType?: ReportPresetType;
  basketId?: number;
  contentIds?: number[];
  contentIdsString?: string[];

  ageMonths?: number;
  tDist?: number;
  months?: number;
  ds?: DataSourceType[];

  aDist?: number;
  datesetMonth?: string;
}

export class ValuationModel implements IValuationModel {
  constructor(
    public reportPresetType: ReportPresetType,
    public basketId: number,
    public contentIds: number[],
    public contentIdsString: string[],

    public ageMonths: number,
    public tDist: number,
    public months: number,
    public ds: DataSourceType[],

    public aDist?: number,
    public datesetMonth?: string,
  ) {

  }

  public static empty() {
    return new ValuationModel(null, null, [], [], null, null, null, [], null, null);
  }
}


